import { Grid, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import { FunctionComponent } from 'react';
import { reduceResolution, wbp } from 'Theme';
import { useCommonStyles } from './CommonStyles';
import { Membership } from '@spike/membership-model';

interface MembershipItemProps {
    membership: Membership;
    className?: string;
    onEdit?: (membershipId: number) => void;
}

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        petRow: {
            cursor: 'pointer',

            [theme.breakpoints.down('sm')]: {
                alignItems: 'center',
                justifyContent: 'space-between'
            },
            [theme.breakpoints.up('md')]: {
                padding: '24px 0px'
            }
        },
        petRowTopBorder: {
            borderTop: '1px solid #DDDDDD'
        },
        text: {
            fontFamily: 'Poppins',
            fontWeight: 400,
            color: 'black',
            [theme.breakpoints.down(wbp)]: {
                fontSize: `${reduceResolution(14)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                fontSize: '14px'
            }
        },
        mainText: {
            fontFamily: 'Poppins',
            fontSize: 14,
            fontWeight: 500,
            display: 'block'
        },
        secondaryText: {
            fontFamily: 'Poppins',
            fontSize: 14,
            fontWeight: 400,
            display: 'block',
            width: '100%',
            color: '#7A7A7A'
        }
    })
);

const MembershipItem: FunctionComponent<MembershipItemProps> = props => {
    const classes = useStyles();
    const commonClasses = useCommonStyles();

    return (
        <>
            {props.membership.membershipItems.map((item, index) => (
                <Grid
                    container
                    item
                    xs={12}
                    key={`${item.id}`}
                    className={clsx(classes.petRow, { [classes.petRowTopBorder]: index > 0 })}
                >
                    <Grid
                        item
                        xl={7}
                        lg={7}
                        xs={12}
                        className={clsx(commonClasses.cellVerticalCenter, commonClasses.bigWidthCell)}
                    >
                        <Typography className={clsx(classes.mainText, commonClasses.cellCenter)}>
                            {item.itemName}
                            <Typography className={clsx(classes.text, classes.secondaryText)}>
                                {item.itemType}
                            </Typography>
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={1}
                        className={clsx(
                            commonClasses.smallWidthCellDetail,
                            commonClasses.cellVerticalCenter,
                            commonClasses.cellRight,
                            commonClasses.desktop
                        )}
                    >
                        <Typography className={clsx(classes.text, commonClasses.desktop, commonClasses.cellCenter)}>
                            {item.unlimited ? 'Unlimited' : item.quantity}
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={1}
                        className={clsx(
                            commonClasses.smallWidthCellDetail,
                            commonClasses.cellVerticalCenter,
                            commonClasses.cellRight,
                            commonClasses.desktop
                        )}
                    >
                        <Typography className={clsx(classes.text, commonClasses.desktop, commonClasses.cellCenter)}>
                            ${Number(item.amount).toFixed(2)}
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={1}
                        className={clsx(
                            commonClasses.smallWidthCellDetail,
                            commonClasses.cellVerticalCenter,
                            commonClasses.cellRight,
                            commonClasses.desktop
                        )}
                    >
                        <Typography className={clsx(classes.text, commonClasses.desktop, commonClasses.cellCenter)}>
                            ${(item.amount * item.quantity).toFixed(2)}
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={1}
                        className={clsx(
                            commonClasses.smallWidthCellDetail,
                            commonClasses.cellVerticalCenter,
                            commonClasses.cellRight,
                            commonClasses.desktop
                        )}
                        style={{ paddingRight: '20px' }}
                    ></Grid>
                </Grid>
            ))}
        </>
    );
};

export default MembershipItem;
